import React from 'react';
import {MainLayout} from 'components/layouts';
import {HomeBannerForm} from 'components/home-banners';
import {HomeBanners} from 'base/api';
import {toastr} from 'react-redux-toastr';
import {connect} from 'react-redux';

class EditHomeBanner extends React.Component {
  constructor(props, context) {
    super(props, context);
    const id = this.props.match && this.props.match.params && this.props.match.params.id;
    let homeBanner = null;
    if (this.props.listHomeBanners && id) {
      homeBanner = this.props.listHomeBanners.find(item => item.id === id);
    }
    this.state = {
      homeBanner,
      id
    }
  }

  componentDidMount() {
    const id = this.props.match && this.props.match.params && this.props.match.params.id;
    if (!id) {
      return;
    }
    if (!this.state.homeBanner && (!this.props.listHomeBanners || this.props.listHomeBanners.length === 0)) {
      HomeBanners.actions.get.request({id}).then(response => {
        this.setState({
          homeBanner: response.data
        });
      });
    }
  }

  componentWillReceiveProps(nexProps) {
    if (nexProps.listHomeBanners && nexProps.listHomeBanners.length > 0 && nexProps.listHomeBanners !== this.props.listHomeBanners) {
      const id = this.props.match && this.props.match.params && this.props.match.params.id;
      let homeBanner = null;
      if (this.props.listHomeBanners && id) {
        homeBanner = this.props.listHomeBanners.find(item => item.id === id);
        this.setState({homeBanner});
      }
    }
  }

  cb(response) {
    // Back to home banners list
    toastr.success('Thành công!', 'Danh mục đã được cập nhật thành công.');

    this.props.history.push('/home-banners');
  }

  render() {
    return (
      <MainLayout>
        <div>
          <div className="register-logo">
            <b>Cập nhật banner</b>
          </div>
          <HomeBannerForm fnSubmit={HomeBanners.actions.update} cb={this.cb.bind(this)} data={this.state.homeBanner}/>
        </div>
      </MainLayout>
    );
  }
}

EditHomeBanner.contextTypes = {
  router: React.PropTypes.object
};

const bindStateToProps = state => {
  return {
    listHomeBanners: state.listHomeBanners
  }
};

export default connect(bindStateToProps)(EditHomeBanner);



// WEBPACK FOOTER //
// ./pages/home-banners/Edit.jsx